import { render, staticRenderFns } from "./BuildCourse.vue?vue&type=template&id=4d596eba&scoped=true&"
import script from "./BuildCourse.vue?vue&type=script&lang=js&"
export * from "./BuildCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d596eba",
  null
  
)

export default component.exports